export const DELETE_SEASON_CONFIRMATION_HEADER = "Delete season";
export const GET_DELETE_SEASON_CONFIRMATION = (seasonName?: string) =>
  `Are you sure you want to delete ${seasonName}?`;
export const CLOSE_MODAL_BUTTON_LABEL = "Close";
export const DELETE_SEASON_BUTTON_LABEL = "Delete";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/season-list/constants.ts